import _ from 'lodash'
import store from "services/redux/store";
import { cartConstants } from 'services/redux/cart/constants'
import FetchBookingCapacity from 'utils/fetch/FetchBookingCapacity'
import { SET_CART } from 'services/redux/action-types'
import HelperValidate from 'utils/helper-validate'
import { routeBookingConstants, routeBookingConstantValues } from 'utils/constants/route/RouteBookingConstants'
import HelperDate, { dateFormat } from 'utils/helper-date'
import { capacityConstants } from 'utils/constants/capacity-constants'
import HelperString from 'utils/helper-string'

const HelperCapacityOverview = {

	getFromStore: () => {
		const capacities = store.getState().cart[ cartConstants.CAPACITIES ];
		
		if( !_.isEmpty( capacities ) ) {
			return capacities;
		}
		
		return {
			capacities: {},
			capacityDates: [],
		};
	},
	
	writeToStore: ( capacities, dates ) => {
		store.dispatch({
			type: SET_CART,
			key: cartConstants.CAPACITIES,
			payload: {
				capacities: {
					...capacities
				},
				capacityDates: [
					...dates
				]
			}
		});
	},
	
	getCapacityKey: ( depthLevel ) =>{
		if( depthLevel === routeBookingConstantValues[ routeBookingConstants.DEPTH_LEVEL ].ROOM  ){
			return 'rooms';
		}
		
		if( depthLevel === routeBookingConstantValues[ routeBookingConstants.DEPTH_LEVEL ].FLOOR  ){
			return 'floors';
		}
		
		return 'buildings';
	},
	
	shouldUpdate: ( date ) => {
		// Not valid?
		if( !HelperValidate.isValid( date ) ) {
			return true;
		}
		
		const { capacityDates } = HelperCapacityOverview.getFromStore();
		
		// Create date objects
		const dateObject = HelperDate.date( date );
		const capacityDate = _.find( capacityDates, { date: dateObject.format( dateFormat.DATE ) } )
		
		// Not valid? update..
		if( !HelperValidate.isValid( capacityDate ) ) {
			return true;
		}
		
		const capacityDateObject = HelperDate.date( capacityDate.updated_at )
		
		// Older than x minutes? update..
		if( HelperDate.date().diff( capacityDateObject, 'second' ) >= 20 ) {
			return true;
		}
		
		// It is ok
		return false;
	},
	
	fetchCapacities: ({ timeslotKinds, timeslotSubKinds, onStart, onComplete, onNothingToDo }) => {
		const { capacityDates } = HelperCapacityOverview.getFromStore();
		
		const date = store.getState().cart[ cartConstants.BOOK_DATE ] ?? HelperDate.date()
		
		const capacityDate = _.find( capacityDates, { date: date.format( dateFormat.DATE ) } )
		
		// If this date has already fetched, just ignore it all
		if( !HelperCapacityOverview.shouldUpdate( capacityDate?.date ) ) {
			onNothingToDo( date );
			return;
		}
		
		// Create a range of dates we want to know
		const dates = [
			date.format( dateFormat.DATE )
		];
		
		for( let dayAddition = 0; dayAddition < 5; dayAddition++ ) {
			const dayAdditionFormatted = date.add( 1, 'day' ).format( dateFormat.DATE );
			
			// Check if we should update
			if( HelperCapacityOverview.shouldUpdate( dayAdditionFormatted ) ) {
				dates.push( dayAdditionFormatted );
			}
		}
		
		FetchBookingCapacity.fetchAllRange( {
			dates: dates,
			kinds: timeslotKinds,
			subKinds: timeslotSubKinds,
			callbackStart: onStart.bind( this, date ),
			callbackSuccess: HelperCapacityOverview.fetchedCapacities.bind( this, dates, onComplete.bind( this, date ) )
		});
	},
	
	fetchedCapacities: ( dates, onComplete, results ) => {
		//const { capacities, capacityDates } = HelperCapacityOverview.getFromStore();
		const { capacityDates } = HelperCapacityOverview.getFromStore();
		
		// Create the list of items we want to store
		const capacityItemList = {
			[ capacityConstants.BUILDINGS ]: 'building_guid',
			[ capacityConstants.FLOORS ]: 'floor_guid',
			[ capacityConstants.ROOMS ]: 'room_guid'
		}
		
		let capacities = {};
		
		// Loop through the results and store them in the correct format
		_.forEach( results, ( result ) => {
			_.forEach( capacityItemList, ( key, capacityKind ) => {
				if( result[ key ] !== null ) {
					if( !HelperValidate.isValid( _.get( capacities, [ capacityKind ], null ) ) ) {
						capacities[ capacityKind ] = {};
					}
					
					if( !HelperValidate.isValid( _.get( capacities, [ capacityKind, result[ key ] ], null ) ) ) {
						capacities[ capacityKind ][ result[ key ] ] = {};
					}
					
					if( !HelperValidate.isValid( _.get( capacities, [ capacityKind, result[ key ], result.date ], null ) ) ) {
						capacities[ capacityKind ][ result[ key ] ][ result.date ] = {};
					}
					
					const kindKey = `${result.timeslot_kind}_${result.timeslot_sub_kind}`;
					if( !HelperValidate.isValid( _.get( capacities, [ capacityKind, result[ key ], result.date, kindKey ], null ) ) ) {
						capacities[ capacityKind ][ result[ key ] ][ result.date ][ kindKey ] = {
							favourites: '',
							capacity: 0,
							remaining: 0,
						};
					}
					
					// And finally set it :)
					if( !HelperString.isEmptyString( result.favourites ) ) {
						capacities[ capacityKind ][ result[ key ] ][ result.date ][ kindKey ].favourites += ( "|||"+result.favourites );
					}
					
					//capacities[ capacityKind ][ result[ key ] ][ result.date ][ kindKey ].capacity += result.capacity;
					//capacities[ capacityKind ][ result[ key ] ][ result.date ][ kindKey ].remaining += result.remaining;
					
					// Do this to not 'sum' all the timeslots together
					if( result.capacity > capacities[ capacityKind ][ result[ key ] ][ result.date ][ kindKey ].capacity ) {
						capacities[ capacityKind ][ result[ key ] ][ result.date ][ kindKey ].capacity = result.capacity;
					}
					if( result.remaining > capacities[ capacityKind ][ result[ key ] ][ result.date ][ kindKey ].remaining ) {
						capacities[ capacityKind ][ result[ key ] ][ result.date ][ kindKey ].remaining = result.remaining;
					}
				}
			})
		});
		
		// Combine the new dates with the old ones
		const dateList = [];
		_.forEach( dates, o => {
			dateList.push({
				date: o,
				updated_at: HelperDate.date().format( dateFormat.DATE_TIME )
			})
		})
		
		_.forEach( capacityDates, o => {
			if( _.find( dateList, { date: o.date } ) === undefined ) {
				dateList.push( o )
			}
		})
		
		HelperCapacityOverview.writeToStore( capacities, dateList );
		
		onComplete();
	}
}

export default HelperCapacityOverview
